var vcDashboardStorage = {

        _storageKeyPrefix: "vcDashboardConfig_",

        save: function (id, config) {
            try {
                localStorage.setItem(this._storageKeyPrefix + id, JSON.stringify(config));
            } catch (e) {
                writeError("dashboard-storage", e); return null;
            }
        },

        load: function (id, callback) {
            try {
                var stored = localStorage.getItem(this._storageKeyPrefix + id);
                if (stored) {
                    var config = JSON.parse(stored);
                    callback(config);
                    return;
                }
            } catch (e) { writeError("dashboard-storage", e); return null; }
        },

        // Unified config: all sub-dashboards in one entry
        saveAll: function (id, allConfigs) {
            try {
                localStorage.setItem(this._storageKeyPrefix + id + "_all", JSON.stringify(allConfigs));
            } catch (e) {
                writeError("dashboard-storage", e); return null;
            }
        },

        loadAll: function (id) {
            try {
                var stored = localStorage.getItem(this._storageKeyPrefix + id + "_all");
                if (stored) {
                    return JSON.parse(stored);
                }
            } catch (e) { writeError("dashboard-storage", e); }
            return {};
        },

        saveSub: function (id, subId, config) {
            var all = this.loadAll(id);
            all[subId] = config;
            this.saveAll(id, all);
        },

        loadSub: function (id, subId) {
            var all = this.loadAll(id);
            return all[subId] || null;
        }

    }